<!-- 首页 -->
<template>
    <div class="container flex flex-column height-all">
        <!-- 顶部搜索模块 -->
        <div class="searchContainer flex-shrink">
            <baseSearch :ref="'selectTableDataRef'" :searchData="searchData" :isShowExport="isShowExport" @searchClick="searchBtnClick" @exportClick="exportBtnClick"/>
        </div>
        <!-- 主体表格 -->
        <div class="mainTable" :style="{'height':tableBoxHeight + 'px'}">
            <basetable tableId="workOrderListTable" tableBoxClass='mainTable' :tableTitle="tableTitle" :tableData="tableData" :showopera="false" :currentPage="searchDataParam.pageNo" operaWidth="140"
                       :isLoading="isLoading" :pageSize="searchDataParam.pageSize" :showNumber="true"
                       :total="total" :showPage="true" @selectionChange="selectionChange" @rowDblclick="rowDblclick"
                       @currentChange="currentChange" @sizeChange="sizeChange" @openUserInfoDetails="openUserInfoDetails">

            </basetable>
        </div>
        <div class="actionBar flex align-center justify-between">
            <div class="flex align-center justify-start">
                <div class="catalogue">{{catalogue || "暂无目录"}}</div>
                <el-button :disabled="isStart" plain type="primary" class="tableOptionBtn" @click="selectCatalogueBtn">请选择导出目录</el-button>
            </div>
            <div>
                <el-button  plain type="primary" class="tableOptionBtn" @click="stopRequestLoop">终止</el-button>
                <el-button :disabled="isStart" plain type="primary" class="tableOptionBtn" @click="startRequestLoop">开始制作</el-button>
            </div>
        </div>
    </div>
    <basedialog title="" :dialogVisible="isShowLoadingCover" :isShowClose="false" :showFooter="false" :close-on-press-escape="false" :close-on-click-modal="false"  @dialogRightTopClose="dialogClose"  center="true" dialogWidth="800">
        <template #dialogbody>
            <div class="flex justify-center flex-column align-center">
                <div class="printIngDiv">
                    <img src="@/static/images/icon_printIng.png" alt="" />
                    <span>生产中，请稍候...</span>
                </div>
                <span class="printIngCount"> 已成功生产<span class="successColor">&nbsp;{{successOrderCount}}&nbsp;</span>个，失败
                    <span class="dangerColor">&nbsp;{{errorOrderCount}}&nbsp;</span>个，剩余
                    <span class="font-bold">&nbsp;{{Number(resultOrderCount) - Number(errorOrderCount) - Number(successOrderCount)}}&nbsp;</span>个</span>
                <div class="descListContainer" ref="descListRef">
                    <div v-for="(item, index) in descList" :key="index" class="descListItem">
                        {{item.desc}}&nbsp;&nbsp;{{item.date}}
                    </div>
                </div>
            </div>
            <div class="dialog-footer" style="justify-content: center;align-items: flex-end;">
                <el-button v-show="!isFinish"  plain type="primary" class="tableOptionBtn" @click="stopRequestLoopNew()">中止</el-button>
                <el-button v-show="isFinish" plain type="primary" class="tableOptionBtn" @click="isShowLoadingCover = false">关闭</el-button>
            </div>
        </template>
    </basedialog>
</template>

<script>
import baseSearch from "@/components/baseSearch"
import basetable from "@/components/basetable"
import basedialog from "@/components/basedialog"
import WangEditor from '@/components/wangEditor'
import preview from '@/utils//juageProType.js'
import tableDataSelect from "@/components/tableDataSelect"
import utils from "../../utils/utils";

export default {
    inject: ['$http', '$api', '$utils','$userUtils'],
    name: "orderList",
    components: {
        baseSearch,
        basetable,
        basedialog,
        tableDataSelect,
        WangEditor
    },
    data() {
        return{
            searchData: [
                {
                    label: "生产账号",
                    type: "select",
                    name: "productAccount",
                    options: [],
                    value: "",
                    isHaveStar: true,
                },{
                    label: "订单号",
                    type: "input",
                    name: "orderNo",
                    value: ""
                },{
                    label: "生产批次",
                    type: "input",
                    name: "productBatch",
                    value: ""
                },{
                    label: "生产编码",
                    type: "input",
                    name: "productNum",
                    value: ""
                },{
                    label: "产品类型",
                    type: "select",
                    name: "prodType",
                    value: "",
                    options: [],
                },{
                    label: "产品名称",
                    type: "input",
                    name: "proName",
                    value: ""
                },{
                    label: "发货单导出格式",
                    type: "select",
                    name: "prodExpressTemplateType",
                    value: "",
                    options: [],
                },{
                    label: "是否打印页码",
                    type: "select",
                    name: "isPrintPage",
                    value: "",
                    options: [{
                        label: "是",
                        value: '1'
                    }, {
                        label: "否",
                        value: '0'
                    }],
                }, {
                    label: "支付时间",
                    type: "datetimerange",
                    name: "payTime",
                    value: ["",""],
                }
            ],
            isLoading: false,
            tableTitle: [
                {
                    label: '订单号',
                    prop: 'orderNo',
                    width:160
                }, {
                    label: '生产编码',
                    prop: 'productNum',
                    width: 250
                },{
                    label: "产品类型",
                    prop: "proTypeStr",
                    width: 120
                }, {
                    label: '产品名称',
                    prop: 'proName',
                    width: 200
                }, {
                    label: '订单状态',
                    prop: 'statusStr',
                    width: 120
                }, {
                    label: 'PDF生成状态',
                    prop: 'pdfStatusStr',
                    width:120
                }, {
                    label: '生产批次号',
                    prop: 'productBatch',
                    width: 120
                }, {
                    label: '支付时间',
                    prop: 'payTime',
                    width:180
                },{
                    label: "收货人",
                    prop: 'addressRealName',
                    width:100
                },{
                    label: "收货人电话",
                    prop: 'addressPhone',
                    width:120
                }, {
                    label: '收货人地址',
                    prop: 'addressDetail',
                    width: 300
                }
            ],
            tableData: [],
            orderIds: [],
            total: 0,
            searchDataParam:{
                pageNo:1,
                pageSize:20,
            },
            tableBoxHeight: 0 ,
            isStart: false,
            productClientType: 'rollBack',
            catalogue: '',
            productSessionId: '',
            timerId: null,
            isShowLoadingCover: false,
            successOrderCount: 0,
            errorOrderCount: 0,
            resultOrderCount: 0,
            isFinish: false,
            productionPageNo: 1,
            productionList: [],
            productionTotal: 0,
            isStop: false,
            productUserOptionsList: [],
            productUserId: '',
            simpleCode: '',
            productCompanyId:'',
            descList: [],
        }
    },
    created() {
        //获取产品会话id
        console.log("created：实例创建完成");
        this.stopRequestLoop();

    },
    beforeUnmount() {
        console.log("beforeUnmount：组件即将销毁，实例仍可用");
        this.productSessionId = '';
        this.stopRequestLoop();
        // this.stopHeartbeat();
    },
    mounted() {
        //获取生产商账号筛选项
        this.getProductUserOptions();
        this.getProductSessionId();
        //公共字典
        this.getCommonDicts();


        this.tableBoxHeight = document.getElementsByClassName("container")[0].offsetHeight - document.getElementsByClassName("searchContainer")[0].offsetHeight - document.getElementsByClassName("actionBar")[0].offsetHeight - 40;

    },

    methods:{

        /**
         * 获取会话id随机数
         */
        getProductSessionId() {
            let that = this;
            that.productSessionId = that.$utils.getRandomNew(8);
            console.log(that.productSessionId)
        },
        /**
         * 获取生产商账号筛选项
         */
        getProductUserOptions() {
            let that = this;
            that.$http.post(that.$api.getProductUserOptionsApi).then(res => {
                if(res.code == 200) {
                    that.searchData[0].options = [];
                    res.data.forEach((item)=>{
                        that.searchData[0].options.push({'label':item.name,'value':item.code})
                    })
                    that.productUserOptionsList = res.data;
                }
            })
        },
        /**
         * 根据类型获取字典数据
         * @param {Object} dictType
         */
        getCommonDicts(dictType) {
            let that = this;
            that.$http.post(that.$api.getCommonDictsApi,{
                "type": "产品类型",
            }).then(res => {
                if(res.code == 200) {
                    that.searchData[4].options = [];
                    res.data.forEach((item)=>{
                        that.searchData[4].options.push({'label':item.name,'value':item.code})
                    })
                }
            })
            that.$http.post(that.$api.getCommonDictsApi, {
                "type": "发货单格式",
            }).then(res => {
                if(res.code == 200) {
                    that.searchData[6].options = [];
                    res.data.forEach((item,index)=>{
                        that.searchData[6].options.push({'label':item.name,'value':item.code})
                    })
                    that.searchData[6].value = "2";
                }
            })
        },
        /**
         * 获取工单列表数据
         */
        initData() {
            let that = this;
            that.loading = true;
            that.$http.postRaw(that.$api.queryUserOrderProductListPageApi,that.searchDataParam ).then(res => {
                that.loading = false;
                if(res.code == 200) {
                    if(that.searchDataParam.pageNo == 1) that.total = res.data.totalCount;
                    that.tableData = res.data.list;
                    if(that.tableData.length > 0) {
                        that.tableData.forEach((item, index) => {
                            item.payTime = that.$utils.isEmpty(item.payTime) ? "--" : that.$utils.getDateTime(item.payTime);

                        })
                    }
                }
            })
        },

        /**
         * 搜索按钮
         */
        searchBtnClick(option){
            let that = this;
            console.log(that.searchData)
            if(this.$utils.isEmpty(option.productAccount)){
                this.$message.warning('请选择生产账号')
                return;
            }
            if (this.$utils.isEmpty(option.payTime)) {
                this.searchDataParam.payStartTime = '';
                this.searchDataParam.payEndTime = '';
            } else {
                this.searchDataParam.payStartTime = option.payTime[0];
                this.searchDataParam.payEndTime = option.payTime[1];
            }
            this.searchDataParam.orderProductQueryType = 4;
            this.searchDataParam = Object.assign(this.searchDataParam,option);
            this.searchDataParam.pageNo = 1;
            console.log(option,this.searchDataParam)
            this.initData()
        },
        /**
         * 设置页码
         */
        currentChange(val){
            this.searchDataParam.pageNo = val;
            this.initData()
        },
        /**
         * 设置页码
         */
        sizeChange(val){
            this.searchDataParam.pageSize = val;
            this.initData()
        },
        /**
         * 选择文件目录
         */
        selectCatalogueBtn() {
            if(window.OrderProductJs){
                let selectOrderProductDir =  window.OrderProductJs.selectOrderProductDir();
                console.log('选择目录',selectOrderProductDir,JSON.parse(selectOrderProductDir))
                if(JSON.parse(selectOrderProductDir).code == 'ok'){
                    this.catalogue = JSON.parse(selectOrderProductDir).data;
                }else {
                    this.$message.error(JSON.parse(selectOrderProductDir).message);
                }
            }
        },
        /**
         * 开始制作
         */
        startRequestLoop() {
            let that = this;
            this.searchDataParam.prodExpressTemplateType = this.searchData[6].value;
            this.searchDataParam.isPrintPage = this.searchData[7].value;
            if(this.isStart){
                this.isShowLoadingCover = true;
                return;
            }
            if(this.$utils.isEmpty(this.catalogue)){
                this.$message.warning('请选择导出目录')
                return;
            }
            if(this.$utils.isEmpty(this.searchDataParam.productAccount) ){
                this.$message.warning('请选择生产账号')
                return;
            }

            that.isFinish = false;
            that.descList = [];  // 开始制作时重置descList
            that.$loading();

            /*setTimeout(()=>{
                if(window.OrderProductJs){
                    let startRollBackOrderProduct =  window.OrderProductJs.startRollBackOrderProduct(this.searchDataParam.productAccount,this.searchDataParam.orderNo,this.searchDataParam.prodType,this.searchDataParam.productName,this.searchDataParam.payStartTime,this.searchDataParam.payEndTime,this.searchDataParam.prodExpressTemplateType,this.searchDataParam.isPrintPage,this.productSessionId,this.searchDataParam.photoBookPdfProduceType);
                    if(JSON.parse(startRollBackOrderProduct).code == 'ok'){
                        this.isStart = true;
                        if (this.timerId) {
                            this.getProductSessionId();
                            clearInterval(this.timerId);
                            this.timerId = null;
                        }
                        this.resultOrderCount = JSON.parse(startRollBackOrderProduct).data;
                        this.fetchData();
                        this.timerId = setInterval(() => this.fetchData(), 2000);
                    }else {
                        this.$message.error(JSON.parse(startRollBackOrderProduct).message);
                    }
                }
            },100)*/

            that.getproductionList();
        },
        /**
         * 循环生产
         */
        getproductionList(){
            let that = this;
            that.$http.postRaw(that.$api.queryUserOrderProductListPageApi,{
                productAccount: that.searchDataParam.productAccount,
                orderProductQueryType: 4,
                prodType: that.searchDataParam.prodType,
                productNum: that.searchDataParam.productNum,
                productBatch: that.searchDataParam.productBatch,
                proName: that.searchDataParam.proName,
                orderNo: that.searchDataParam.orderNo,
                payStartTime: that.searchDataParam.payStartTime,
                payEndTime: that.searchDataParam.payEndTime,
                prodExpressTemplateType: that.searchDataParam.prodExpressTemplateType,
                photoBookPdfProduceType: that.searchDataParam.photoBookPdfProduceType,
                isPrintPage: that.searchDataParam.isPrintPage,
                pageSize: 50,
                pageNo: that.productionPageNo,
                isReturnOrderIds: 1,
            }).then(res => {
                if(res.code == 200) {

                    if(that.$utils.isEmpty(res.data.list)){
                        this.$message.warning('数据为空')
                        this.$loading().close();
                        return;
                    }
                    if(that.productionPageNo == 1){
                        that.productionList = [];
                        that.productionTotal = res.data.totalCount;
                        that.resultOrderCount  = res.data.totalCount;
                        that.productUserId = that.searchDataParam.productAccount;
                        that.productUserOptionsList.forEach((item,index)=>{
                            if(item.code == that.productUserId){
                                that.simpleCode = item.simpleCode;
                                that.productCompanyId = item.companyId;
                            }
                        })
                    }
                    that.productionPageNo ++;
                    that.productionList.push(...res.data.list);
                    if(that.productionList.length >= that.productionTotal){

                        that.isStop = false;
                        let sendMsgJson = '';
                        sendMsgJson = JSON.stringify({
                            "orderId": that.productionList[0].orderId,
                            "orderUserId": that.productionList[0].orderUserId,
                            "productDir": that.catalogue,
                            "productSessionId": that.productSessionId,
                            "productSourceType": 3,
                            "prodExpressTemplateType": that.searchDataParam.prodExpressTemplateType,
                            "isPrintPage": that.searchDataParam.isPrintPage,
                            "productUserId": that.productUserId,
                            "simpleCode": that.simpleCode,
                            "productCompanyId": that.productCompanyId,
                        })
                        if (this.timerId) {
                            this.getProductSessionId();
                            clearInterval(this.timerId);
                            this.timerId = null;
                        }
                        this.fetchData();
                        this.timerId = setInterval(() => this.fetchData(), 10000);
                        this.isShowLoadingCover = true;
                        this.isStart = true;

                        if(window.NativeMQSender){
                            let sendMsg =  window.NativeMQSender.sendMsg("orderProduct","startOrderProduct",sendMsgJson);
                            console.log("sendMsg结果",sendMsg)
                        }
                        that.starProduction();
                        this.$loading().close();
                    }else {
                        that.getproductionList();
                    }
                }
            })
        },
        async starProduction() {
            let that = this;
            for (const [index, item] of this.productionList.entries()) {
                while (true) {
                    try {
                        console.log("index,item",index,item)
                        // 等待接口返回结果
                        const result = await this.$http.post(this.$api.queryOrderPdfStatusApi,{
                            "orderId": item.orderId,
                            "osUserId": item.orderUserId
                        });


                        // 1. 如果返回 null，立即中止整个流程
                        if (this.isStop) {
                            break;
                            console.log(`停止所有任务处理。`);
                            return; // 退出整个 processTasks 函数
                        }

                        // 2. 如果 isTrue 为 true，说明任务完成，跳出 while 循环，继续下一个 for 循环
                        if (result.data == 1 || result.data == 2) {
                            console.log(`继续下一个任务`);
                            if(index == this.productionList.length - 1){
                                break;
                            }else {
                                let sendMsgJson = '';
                                sendMsgJson = JSON.stringify({
                                    "orderId": that.productionList[index + 1].orderId,
                                    "orderUserId": that.productionList[index + 1].orderUserId,
                                    "productDir": that.catalogue,
                                    "productSessionId": that.productSessionId,
                                    "productSourceType": 3,
                                    "prodExpressTemplateType": that.searchDataParam.prodExpressTemplateType,
                                    "isPrintPage": that.searchDataParam.isPrintPage,
                                    "productUserId": that.productUserId,
                                    "simpleCode": that.simpleCode,
                                    "productCompanyId": that.productCompanyId,
                                })

                                if(window.NativeMQSender){
                                    let sendMsg =  window.NativeMQSender.sendMsg("orderProduct","startOrderProduct",sendMsgJson);
                                    console.log("sendMsg结果",sendMsg)
                                }
                                break;
                            }

                        }
                        // 3. 如果 isTrue 为 false，说明任务仍在进行中，等待2秒后重试
                        else {
                            console.log(`将在 4 秒后重试...`);
                            await this.delay(4000); // 等待4秒
                            // 循环会自动继续，再次执行 checkTaskStatus
                        }
                    } catch (error) {
                        // 4. 捕获接口报错（如网络错误），停止循环
                        console.error(`停止所有任务处理 ,错误: ${error.message}`);
                        await this.delay(4000); // 等待4秒
                    }
                }
            }

        },
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        /**
         * 中止
         */
        stopRequestLoop() {
            this.$http.post(this.$api.clearProductSessionResultDescApi,{
                productSessionId: this.productSessionId
            }).then(res => {})
            this.isStart = false;
            this.isStop = true;
            this.productionPageNo = 1;
            this.descList = [];  // 中止/完成时重置descList
            this.getProductSessionId();
            if (this.timerId) {
                clearInterval(this.timerId);
                this.timerId = null;
            }

        },
        /**
         * 中止
         */
        stopRequestLoopNew() {
            this.$http.post(this.$api.clearProductSessionResultDescApi,{
                productSessionId: this.productSessionId
            }).then(res => {})
            this.isStop = true;
            this.isStart = false;
            this.isShowLoadingCover = false;
            this.productionPageNo = 1;
            this.descList = [];  // 中止时重置descList
            this.getProductSessionId();
            if (this.timerId) {
                clearInterval(this.timerId);
                this.timerId = null;
            }

        },
        /**
         * 循环输出
         */
        fetchData(){
            let that = this;
            that.$http.post(that.$api.queryProductSessionResultDescApi,{
                productSessionId: that.productSessionId,
                prodUserId: that.searchDataParam.productAccount,
                prodOrderType: ''
            }).then(res => {
                that.loading = false;
                if(res.code == 200) {
                    that.successOrderCount = res.data.successOrderCount;
                    that.errorOrderCount = res.data.errorOrderCount;
                    // 获取descList并追加到已有数据，自动滚动到底部
                    if(res.data.descList && res.data.descList.length > 0) {
                        that.descList.push(...res.data.descList);
                        that.$nextTick(() => {
                            that.scrollToBottom();
                        });
                    }
                    if(Number(that.successOrderCount) + Number(that.errorOrderCount) >= Number(that.resultOrderCount)){
                        that.isFinish = true;
                        that.stopRequestLoop();
                    }
                }
            })
        },
        dialogClose() {
            this.isShowLoadingCover = false;
        },
    },
}
</script>
<style scoped>
.mainCont .container{
    padding: 0;
    background-color: #F5FBFF;
    border-radius: 12px;
    box-sizing: border-box;
}
.searchContainer{
    background: #fff;
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 20px;
}
.mainTable{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    height: 62%;
    overflow: hidden;
    margin-bottom: 20px;
}

.actionBar{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    height: 4%;
}
.catalogue{
    margin-right: 20px;
    font-size: 14px;
}
.printIngDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #333333;
}

.printIngDiv img {
    width: 18px;
    margin-right: 10px;
}

.printIngCount {
    font-size: 16px;
    color: #666666;
    margin-top: 20px;
}

.printIngDiv .el-icon{
    margin-right: 10px;

    color: #ff0000;
}
.descListContainer {
    width: 100%;
    height: 400px;
    overflow-y: auto;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-top: 20px;
    padding: 10px;
    box-sizing: border-box;
    background-color: #f9f9f9;
}

.descListItem {
    padding: 8px 12px;
    margin-bottom: 6px;
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    word-break: break-all;
}

.descListItem:last-child {
    margin-bottom: 0;
}
</style>
<style>

</style>